import React, { useEffect, useState } from 'react';
import { Input } from '@mui/material';
const decimalRegex = /^-?((\d{1,10}|0\.\d{1,2})($|\.$|\.\d{1,2}$))/g;

/**
 * @typedef {object} MuiInputDecimalProps
 * @property {string} [className]
 * @property {string} [placeholder]
 * @property {(event: React.ChangeEvent<HTMLInputElement>) => void} handleOnChange
 * @property {string|number} [value]
 * @property {boolean} [disabled]
 * @property {Object} [customStyle]
 * @property {string} [dataTestId]
 */

/**
 * @param {MuiInputDecimalProps} props
 */
const MuiInputDecimal = props => {
  const {
    handleOnChange,
    className = '',
    placeholder = '',
    value = '',
    disabled = false,
    customStyle = undefined,
    dataTestId = ''
  } = props;

  const [innerValue, setInnerValue] = useState(value !== null ? value : '');

  useEffect(() => {
    setInnerValue(value !== null ? value : '');
  }, [value]);

  const onChange = e => {
    const rawValue = e.target.value;

    if (rawValue === '-') {
      setInnerValue(rawValue);
      return;
    }

    if (!rawValue) {
      setInnerValue(rawValue);
      handleOnChange(e);
      return;
    }

    if (!rawValue.match(decimalRegex)) {
      return;
    }

    setInnerValue(rawValue);
    handleOnChange(e);
  };

  return (
    <Input
      data-testid={dataTestId}
      className={className}
      disableUnderline
      placeholder={placeholder}
      onChange={onChange}
      value={innerValue}
      disabled={disabled}
      style={customStyle}
    />
  );
};

export default MuiInputDecimal;
